<template>
    <div>
      <b-list-group>
          <nav-item v-for="item in items" :item="item" :key="item.id" :selected="selected"></nav-item>
      </b-list-group>
    </div>
</template>

<script>
export default {
  data() {
    return {};
  },

  props: {
    items: {
      type: Array,
      required: true
    },
    selected: {
      required: false
    }
  }
};
</script>

<style>
</style>
